import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { format, subDays } from 'date-fns';
import { APIStatus, APIError } from '../../@types/APIStatus';
import {
  ABCAnalysisFilterBarState,
  StockHealthFilterBarState
} from '../../@types/filterBars';
import { ABCAnalysisState, StockHealthState } from '../../@types/reduxStates';
import {
  ABCAnalysisResponse,
  StockHealthResponse
} from '../../@types/responsesAPI';
import { axiosInstance } from '../../utils/axiosConfig';

const initialState: ABCAnalysisState = {
  filters: {
    timePeriod: 1,
    dateRange: {
      startFilter: format(subDays(new Date(), 30), 'yyyy-MM-dd'),
      endFilter: format(subDays(new Date(), 0), 'yyyy-MM-dd')
    }
  },
  response: {
    rows: [],
    total: {
      abcCategory: '',
      shareOfSales: 0,
      skuCount: 0
    },
    totalCount: 0
  },
  APIStatus: APIStatus.IDLE
};

const slice = createSlice({
  name: 'abcAnalysis',
  initialState,
  reducers: {
    setFilters: (
      state: ABCAnalysisState,
      action: PayloadAction<ABCAnalysisFilterBarState>
    ) => {
      state.filters = action.payload;
    },
    getABCAnalysis: (state: ABCAnalysisState) => {
      state.error = undefined;
      state.APIStatus = APIStatus.PENDING;
    },
    getABCAnalysisSuccess: (
      state: ABCAnalysisState,
      action: PayloadAction<ABCAnalysisResponse>
    ) => {
      state.response = action.payload;
      state.APIStatus = APIStatus.FULFILLED;
    },
    getABCAnalysisError: (
      state: ABCAnalysisState,
      action: PayloadAction<APIError>
    ) => {
      state.error = action.payload;
      state.APIStatus = APIStatus.REJECTED;
    }
  }
});

export function fetchAbcAnalysys(
  filters: ABCAnalysisFilterBarState,
  signal: AbortSignal
) {
  return async (dispatch: any) => {
    try {
      dispatch(setFilters(filters));
      dispatch(getABCAnalysis());
      const response = await axiosInstance.get(
        '/api/v2/dashboard/abcAnalysys',
        {
          signal,
          params: {
            from: filters.dateRange.startFilter,
            till: filters.dateRange.endFilter,
            timePeriod: filters.timePeriod
          }
        }
      );
      dispatch(getABCAnalysisSuccess(response.data));
    } catch (error) {
      dispatch(getABCAnalysisError(error as APIError));
    }
  };
}

export const {
  setFilters,
  getABCAnalysis,
  getABCAnalysisError,
  getABCAnalysisSuccess
} = slice.actions;

// Reducer
export default slice.reducer;
